import React from 'react';

import { IconContext } from 'phosphor-react';

import { ArrowDown, ArrowUp } from 'components/shared/Icon/phosphorIcons';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import { useNavigationArrow } from './functions';
import s from './index.module.css';

export const NavigationArrow = () => {
  const { isTabletOrMobile } = useMediaBreakpoints();
  const { isLastLink, onScrollHandler } = useNavigationArrow();

  if (isTabletOrMobile) {
    return null;
  }

  return (
    <div className={s.temporalScrollArrowContainer}>
      <IconContext.Provider value={{ size: 33, weight: 'thin', className: s.scrollArrow, onClick: onScrollHandler }}>
        {isLastLink ? <ArrowUp /> : <ArrowDown />}
      </IconContext.Provider>
    </div>
  );
};
